import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconSocialLinkedinActive({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="#0A66C2" fillRule="evenodd" d="M20.517 2.5H3.483C2.678 2.5 2 3.136 2 3.94v17.12c0 .804.657 1.44 1.483 1.44h17.034c.826 0 1.483-.657 1.483-1.44V3.94c0-.783-.657-1.44-1.483-1.44M7.958 9.973v9.542H4.96V9.973zm-1.5-4.75a1.72 1.72 0 0 1 1.736 1.718A1.72 1.72 0 0 1 6.459 8.66 1.72 1.72 0 0 1 4.724 6.94a1.72 1.72 0 0 1 1.735-1.717m6.162 4.786H9.76v9.58h2.965v-4.726c0-1.25.233-2.459 1.778-2.459 1.525 0 1.546 1.42 1.546 2.523v4.641h2.965v-5.235c0-2.586-.55-4.557-3.558-4.557-1.44 0-2.392.806-2.795 1.547h-.042z" clipRule="evenodd" /></svg></>;
}
export default IconSocialLinkedinActive;